import useTranslation from '@space-lib/hooks/useTranslation'
import { ThemeMode } from '@space-lib/styles/themes/enum'

import CustomTextArea from '@space-shell/common/components/customTextarea'
import useThemeContext from '@space-shell/common/hooks/useThemeContext'

import clsx from 'clsx'

import { EXPECTED_SUCCESS_OPTIONS, EXPECTED_SUCCESS_VALUES } from './constants'

import { MAX_SIZE } from '../constants'
import useDeleteCommunityModal from '../hooks/useDeleteCommunityModal/useDeleteCommunityModal'
import { Radio } from '../styles'

const ExpectedSuccessStep = () => {
  const { t } = useTranslation()
  const { theme } = useThemeContext()
  const {
    expectedSuccesSelectedOption,
    setExpectedSuccesSelectedOption,
    expectedSuccessText,
    setExpectedSuccessText
  } = useDeleteCommunityModal()

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setExpectedSuccessText(event.target.value)
  }

  const shouldRenderAnotherMotivateTextarea =
    expectedSuccesSelectedOption === EXPECTED_SUCCESS_VALUES.ANOTHER_MOTIVE

  return (
    <>
      <p className='_mb-4  _text-gray-700'>
        {t('community_survey.delete_community.expected_success.title')}
      </p>
      {EXPECTED_SUCCESS_OPTIONS.map((option, index) => {
        const isLastElement = index === EXPECTED_SUCCESS_OPTIONS.length - 1

        return (
          <div key={option.value}>
            <Radio
              id={String(option.value)}
              name='expected-success-options'
              aria-label={t(option.label)}
              value={option.value}
              checked={option.value === expectedSuccesSelectedOption}
              onChange={() => setExpectedSuccesSelectedOption(option.value)}
              $isDarkMode={theme === ThemeMode.DARK}
            />
            <label
              htmlFor={option.value}
              className={clsx('_ml-5 _text-gray-600', {
                '_mb-0': isLastElement,
                '_mb-2': !isLastElement
              })}>
              {t(option.label)}
            </label>
          </div>
        )
      })}

      {shouldRenderAnotherMotivateTextarea && (
        <CustomTextArea
          name='expected-success-another-motive-textarea'
          value={expectedSuccessText}
          onChange={handleChange}
          placeholder={t('community_survey.delete_community.text_area_placeholder')}
          maxSize={MAX_SIZE}
          currentSize={expectedSuccessText.length}
          className='_mt-5 _mb-0 _text-gray-900 _mt-2'
        />
      )}
    </>
  )
}

export default ExpectedSuccessStep
